/* eslint-disable @typescript-eslint/no-unsafe-member-access */
import {
  DraftEntity,
  RawDraftContentState,
} from '@msd-npm-gmc-dev/gmc-dc-assembler-draftjs2lexical';
import * as Models from 'models';

export const removeAbbreviationEntities = (content: RawDraftContentState, entityIndex: string): void => {
  for (const block of (content.blocks)) {
    block.entityRanges = block.entityRanges.filter(range => range.key.toString() !== entityIndex);
  }

  delete content.entityMap[entityIndex];
};
// This function removes abbreviations when project is newly opened and never been converted to lexical
export function removeAbbreviationsIfNotPresentDraftJS(
  textAbbreviationDocuments: Models.TextAbbreviationDocumentsArray,
  rawContent: string | undefined): string {
  if (!rawContent) {
    return 'null';
  }
  const content = JSON.parse(rawContent) as RawDraftContentState;

  if (!content?.entityMap) {
    return rawContent;
  }

  for (const entityIndex in content.entityMap) {
    const entity = content.entityMap[entityIndex];
    const isTextAbbreviationDocumentPresent = Boolean(textAbbreviationDocuments[entity.data.id as string]);
    if (entity.type === DraftEntity.ABBREVIATION && !isTextAbbreviationDocumentPresent) {
      removeAbbreviationEntities(content, entityIndex);
    }
  }

  return JSON.stringify(content);
}
